import React, { useEffect, useState } from 'react'
import './InterviewForInterview.css';

import Select from 'react-select';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
// import TimePicker from 'react-time-picker';

const InterviewForInterview = () => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  const [profileId, setProfileId] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [selectedInterviewer, setSelectedInterviewer] = useState(null);
  const [basedonEmployeeId, setBasedEmployeeId] = useState({});
  const [interviewerEmail, setInterviewerEmail] = useState('');
  const [interviewerContact, setInterviewerContact] = useState('');
  const [candidateEmail, setCandidateEmail] = useState('');
  const [candidateContact, setCandidateContact] = useState('');
  const selectedProfileId = localStorage.getItem("selectedProfileId");
  const selectedProfileValue = localStorage.getItem('selectedProfileIdValue');
console.log("jnhbv",selectedProfileId);
console.log("jnhbhuj ikolpv",selectedProfileValue);
  const [profileInput, setProfileInput] = useState(selectedProfileId || '');
  const [remarks, setRemarks] = useState(localStorage.getItem('remark') || '');
  const [location, setLocation] = useState('');
  const [jobDisplay, setJobDisplay] = useState(''); // for showing in input
  const [jobId, setJobId] = useState(''); // pure ID for payload
   const [isInterFocused, setIsInterFocused] = useState(false);
    const isInterLabelFloated = isInterFocused || !!selectedInterviewer;
  const navigate = useNavigate();

  const [formErrors, setFormErrors] = useState({});
  useEffect(() => {
    const storedJobId = localStorage.getItem('selectedJobId');
    const storedJobLabel = localStorage.getItem('selectedJobLabel');

    if (storedJobId && storedJobLabel) {
      setJobDisplay(storedJobLabel); // "220001 - Software Engineer"
      setJobId(storedJobId);         // just "220001"
    }
  }, []);


  useEffect(() => {
    if (selectedProfileValue) {
      axios.get(`${process.env.REACT_APP_API_BASE_URL}/personal-info/${selectedProfileValue}`)
        .then(response => {
          setProfileId(response.data);
          setCandidateEmail(response.data.email || '');
          setCandidateContact(response.data.mobileNumber || '');
        })
        .catch(error => console.error('Error fetching profile:', error));
    }
  }, [selectedProfileValue]);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/master`)
      .then(response => setEmployees(response.data))
      .catch(error => console.error("Error fetching employees:", error));
  }, []);

  const interviewerOptions = employees.map(employee => ({
    value: employee.employeeId,
    label: employee.employeeName
  }));
  // Persist selectedDate
  const handleDateChange = (date) => {
    const parsedDate = new Date(date);  // Make sure it's a Date object
    if (parsedDate instanceof Date && !isNaN(parsedDate)) {
      setSelectedDate(parsedDate);
      localStorage.setItem('interviewDate', parsedDate);
    } else {
      console.error("Invalid date selected:", date);
    }
  };


  const handleTimeChange = (time) => {
    setSelectedTime(time);
    localStorage.setItem('interviewTime', time);
  };

  useEffect(() => {
    // Store selectedDate in localStorage when it changes
    if (selectedDate) {
      localStorage.setItem('interviewDate', selectedDate);
    }
  }, [selectedDate]);

  useEffect(() => {
    // Store selectedTime in localStorage when it changes
    if (selectedTime) {
      localStorage.setItem('interviewTime', selectedTime);
    }
  }, [selectedTime]);

  useEffect(() => {
    const storedLocation = localStorage.getItem('interviewLocation');
    if (storedLocation) {
      setLocation(storedLocation);
    }
  }, []);


  useEffect(() => {
    if (selectedInterviewer) {
      localStorage.setItem('selectedInterviewerValue', JSON.stringify(selectedInterviewer));
    }
  }, [selectedInterviewer]);
  useEffect(() => {
    const storedEmail = localStorage.getItem('interviewerEmail');
    const storedContact = localStorage.getItem('interviewerContact');

    if (storedEmail) setInterviewerEmail(storedEmail);
    if (storedContact) setInterviewerContact(storedContact);
  }, []);

  // Persist location
  useEffect(() => {
    localStorage.setItem('interviewLocation', location);
  }, [location]);

  // Persist selectedInterviewer
  useEffect(() => {
    if (selectedInterviewer) {
      localStorage.setItem('selectedInterviewerValue', JSON.stringify(selectedInterviewer));
    }
  }, [selectedInterviewer]);
  useEffect(() => {
    const storedDate = localStorage.getItem('interviewDate');
    const storedTime = localStorage.getItem('interviewTime');
    const storedLocation = localStorage.getItem('interviewLocation');
    const storedInterviewer = localStorage.getItem('selectedInterviewerValue');

    if (storedDate) setSelectedDate(new Date(storedDate));
    if (storedTime) setSelectedTime(new Date(storedTime));
    if (storedLocation) setLocation(storedLocation);
    if (storedInterviewer) {
      const parsed = JSON.parse(storedInterviewer);
      setSelectedInterviewer(parsed);
      handleInterviewerChange(parsed); // <-- trigger API call
    }

  }, []);



  useEffect(() => {
    const storedDate = localStorage.getItem('interviewDate');
    const storedTime = localStorage.getItem('interviewTime');
    const storedLocation = localStorage.getItem('interviewLocation');
    const storedInterviewerEmail = localStorage.getItem('interviewerEmail');
    const storedInterviewerContact = localStorage.getItem('interviewerContact');
    const storedCandidateEmail = localStorage.getItem('candidateEmail');
    const storedCandidateContact = localStorage.getItem('candidateContact');

    if (storedDate) setSelectedDate(new Date(storedDate));
    if (storedTime) setSelectedTime(storedTime);
    if (storedLocation) setLocation(storedLocation);
    if (storedInterviewerEmail) setInterviewerEmail(storedInterviewerEmail);
    if (storedInterviewerContact) setInterviewerContact(storedInterviewerContact);
    if (storedCandidateEmail) setCandidateEmail(storedCandidateEmail);
    if (storedCandidateContact) setCandidateContact(storedCandidateContact);
  }, []);

  const handleInterviewerChange = (selectedOption) => {
    setSelectedInterviewer(selectedOption);
    if (selectedOption) {
      axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/master/employee/${selectedOption.value}`)
        .then(response => {
          setBasedEmployeeId(response.data);
          setInterviewerEmail(response.data.emailAddress || '');
          setInterviewerContact(response.data.contactNumber || '');
        })
        .catch(error => console.error("Error fetching employee data:", error));
    }

  };

 const handleSubmit = (e) => {
    e.preventDefault();
    
const profileIdRawId = localStorage.getItem('selectedProfileIdValue') || ''; // "4GP1040 - hbn "
const profileIdRaw = localStorage.getItem('selectedProfileId') || ''; // "4GP1040 - hbn "

// Extract name part after the dash " - "
const nameFromProfileId = profileIdRaw.includes(' - ') 
  ? profileIdRaw.split(' - ')[1].trim() 
  : ''; // fallback empty string if no dash

const data = {
  jobId: localStorage.getItem('selectedJobId'),
  positionName: localStorage.getItem('selectedJobLabel')?.includes(' - ') 
    ? localStorage.getItem('selectedJobLabel').split(' - ')[1].trim() 
    : localStorage.getItem('selectedJobLabel'),
  profileId: profileIdRawId,
  name: nameFromProfileId,
  status: localStorage.getItem('selectedStatus') || 'approved',
  remarks: localStorage.getItem('remark') || '',
  interviewerName: selectedInterviewer?.label,
  interviewerEmail: basedonEmployeeId.emailAddress,
  interviewerContact: basedonEmployeeId.contactNumber,
  candidateEmail: candidateEmail,
  candidateContact: candidateContact,
  date: selectedDate ? selectedDate.toISOString().split('T')[0] : '',
  time: selectedTime,
  location
};






    axios.post(`${process.env.REACT_APP_API_BASE_URL}/shortlist`, data)
        .then(response => {
            console.log('Interview data submitted:', response);

            // ✅ Add Approved profile to processedProfiles
            const profileIdOnly = localStorage.getItem('selectedProfileIdValue');
            const processedProfiles = JSON.parse(localStorage.getItem('processedProfiles') || '[]');
            if (!processedProfiles.includes(profileIdOnly)) {
                processedProfiles.push(profileIdOnly);
                localStorage.setItem('processedProfiles', JSON.stringify(processedProfiles));
            }

            // ✅ Clear localStorage
            localStorage.removeItem('selectedProfileId');
            localStorage.removeItem('selectedProfileIdValue');
            localStorage.removeItem('remark');
            localStorage.removeItem('selectedJobId');
            localStorage.removeItem('selectedJobLabel');
            localStorage.removeItem('selectedStatus');
            localStorage.removeItem('interviewLocation');
            localStorage.removeItem('selectedInterviewerValue');
            localStorage.removeItem('interviewerEmail');
            localStorage.removeItem('interviewerContact');
            localStorage.removeItem('interviewTime');
            localStorage.removeItem('interviewDate');

            // ✅ Clear state
            setSelectedDate('');
            setSelectedTime('');
            setSelectedInterviewer(null);
            setBasedEmployeeId({});
            setLocation('');
            setRemarks('');
            setInterviewerEmail('');
            setInterviewerContact('');
            setCandidateEmail('');
            setCandidateContact('');
            setProfileInput('');
            setJobId('');
            setJobDisplay('');
        })
        .catch(error => {
            console.error('Error submitting interview data:', error);
        });
};

  const isFormValid =
    profileInput.trim() &&
    selectedDate &&
    selectedTime &&
    location.trim() &&
    selectedInterviewer &&
    interviewerEmail &&
    interviewerContact &&
    candidateEmail &&
    candidateContact;
  const handleBack = () => {
    navigate('/shortList'); // Replace with the actual route path of your shortlist page
  };

  return (
    <div>
      <div className='main-div-interview'>
        <h3 className='interview-headding'>Interview Scheduling Details</h3>
        <form onSubmit={handleSubmit}>
          <div className='interview'>
            <label><span className='required'>*</span>Job Id</label>
            <input
              type="text"
              placeholder='Job Id'
              value={jobDisplay}
              readOnly
            />
          </div>
          <div className={`interview ${formErrors.profileInput ? 'did-error-input' : ''}`}>

            <input
              type="text"
              placeholder=''
              value={profileInput}
              onChange={(e) => setProfileInput(e.target.value)}
              required className="interview-input"
            />
            <label className="interview-label"><span className='required'>*</span>Profile Id</label>
          </div>
          <div className="interview-input-label-content-select">
            <label className={`interview-floating-label-select ${isInterLabelFloated ? 'label-float-select' : ''}`}><span className="required">*</span>Interviewer Name</label>
            <Select
              options={interviewerOptions} // Pass the options to the select component
              placeholder=" "
              onFocus={() => setIsInterFocused(true)}
              onBlur={() => setIsInterFocused(false)}
              classNamePrefix="react-select"
              value={selectedInterviewer} // Set the selected interviewer
              onChange={handleInterviewerChange} // Handle interviewer selection
            />
          </div>
          <div className={`interview ${formErrors.selectedDate ? 'did-error-input' : ''}`}>
            <input
              type="date"
              value={selectedDate ? selectedDate.toISOString().split('T')[0] : ''}
              onChange={(e) => handleDateChange(e.target.value)}
              className="interview-input"
            />
            <label className="interview-label"><span className="required">*</span>Date</label>
          </div>

          <div className={`interview ${formErrors.selectedTime ? 'did-error-input' : ''}`}>
            <input
              type="time"
              value={selectedTime || ''}
              onChange={(e) => handleTimeChange(e.target.value)}
              className="interview-input"
            />
            <label className="interview-label"><span className="required">*</span>Time</label>
          </div>

          <div className={`interview ${formErrors.location ? 'did-error-input' : ''}`}>

            <input type="text" className="interview-input"

              onChange={(e) => setLocation(e.target.value)}
              value={location}
              placeholder="" required />
            <label className="interview-label"><span className="required">*</span>Location</label>
          </div>

          <div className={`interview ${formErrors.interviewerEmail ? 'did-error-input' : ''}`}>
            <input
              type="text" className="interview-input"
              placeholder=''
              value={interviewerEmail}
              readOnly
              required
            />
            <label className="interview-label"><span className="required">*</span>Interviewer Email</label>

          </div>

          <div className={`interview ${formErrors.interviewerContact ? 'did-error-input' : ''}`}>
            <input
              type="text" className="interview-input"
              placeholder=''
              value={interviewerContact}
              readOnly
              required
            />
            <label className="interview-label"><span className="required">*</span>Interviewer Phone Number</label>
          </div>

          <div className={`interview ${formErrors.candidateEmail ? 'did-error-input' : ''}`}>
            <input
              type="text" className="interview-input"
              value={candidateEmail}
              readOnly
              required
            />
            <label className="interview-label"><span className="required">*</span>Candidate Email</label>
          </div>

          <div className={`interview ${formErrors.candidateContact ? 'did-error-input' : ''}`}>
            <input
              type="text" className="interview-input"

              placeholder=''
              value={candidateContact}
              readOnly
              required
            />
            <label className="interview-label"><span className="required">*</span>Candidate Phone Number</label>

          </div>
          <div className='btn-s'>
            <button className='btn-style' type="button" onClick={handleBack}>
              Previous
            </button>
            <button className='btn-style' type="submit" disabled={!isFormValid}>Submit
            </button>

          </div>
        </form>

      </div>

    </div>
  )
}

export default InterviewForInterview